module.exports = __webpack_public_path__ + "static/media/edit.eb51b821.svg";